import type { FormState, UserTypeConfig, UserType } from '@/shared/types/users.types';
import { isDriverUserType } from '@/shared/types/users.types';

export function StepConsents({
    form,
    set,
    config,
    userType,
}: {
    form: FormState;
    set: <K extends keyof FormState>(k: K, v: FormState[K]) => void;
    config: UserTypeConfig;
    userType: string;
}) {
    const isDriver = isDriverUserType(userType as UserType);
    const name = form.firstName ? `${form.firstName} ${form.lastName}`.trim() : '—';

    const checkboxes = [
        { key: 'acceptTerms' as const, text: "J'accepte les conditions générales d'utilisation", required: true },
        { key: 'acceptPrivacy' as const, text: "J'accepte la politique de confidentialité", required: true },
        ...(isDriver ? [
            { key: 'acceptVerification' as const, text: "J'autorise la vérification de mes documents", required: true },
            { key: 'acceptQuality' as const, text: "Je m'engage à respecter les délais et normes de qualité", required: true },
        ] : []),
        { key: 'acceptNotifications' as const, text: 'Recevoir les notifications par SMS et e-mail', required: false },
    ];

    return (
        <div className="space-y-5">
            <h2 className="text-xl font-semibold text-gray-900">Validation finale</h2>

            <div className="bg-gray-50 rounded-xl p-4 text-sm space-y-1">
                <p className="font-medium text-gray-800 mb-2">Récapitulatif</p>
                <div className="space-y-1 text-gray-600">
                    <p><span className="font-medium">Type :</span> {config.label}</p>
                    {name !== '—' && <p><span className="font-medium">Nom :</span> {name}</p>}
                    {form.email && <p><span className="font-medium">Email :</span> {form.email}</p>}
                    {form.phone && (
                        <p><span className="font-medium">Téléphone :</span> {form.phoneCountryCode}{form.phone}</p>
                    )}
                </div>
            </div>

            <div className="space-y-3">
                {checkboxes.map(cb => (
                    <label key={cb.key} className="flex items-start gap-3 cursor-pointer">
                        <input
                            type="checkbox"
                            checked={form[cb.key] as boolean}
                            onChange={e => set(cb.key, e.target.checked)}
                            className="mt-0.5 w-4 h-4 rounded border-gray-300 text-teal-600 focus:ring-teal-500"
                        />
                        <span className="text-sm text-gray-700">
                            {cb.text}
                            {cb.required && <span className="text-red-500 ml-1">*</span>}
                        </span>
                    </label>
                ))}
            </div>
        </div>
    );
}
